define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var CONST = require("const");
    var template = require("personalization-web-agent-templates/widget-templates/widget-edit/widgetEdit.tmpl");

    var Config = require("personalization-web-agent-config/config.json");
    var lpUtils = require('utils/lpUtils');

    var Button = require("ui/button/Button");
    var Checkbox = require("ui/checkbox/Checkbox");
    var InputField = require("ui/input-field/InputField");
    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var InlineInput = require("ui/inline-input/InlineInput");
    var Dropdown = require("ui/dropdown/Dropdown");
    var TextareaField = require("ui/textarea-field/TextareaField");
    var Multiselect = require("ui/multiselect/Multiselect");
    var List = require("ui/list/List");
    var TagsContainer = require("ui/tags-container/TagsContainer");
    var Loader = require("ui/loader/Loader");

    var WidgetModel = require("personalization-web-agent-models/WidgetModel");

    var WidgetEditView = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetEditView = Marionette.ItemView.extend({
            className: "widget-edit",
            template: template,
            ui: {
                "editContainer": ".edit-widget-container",
                "cancelButton": ".edit-widget-cancel",
                "saveButton": ".edit-widget-save",
                "pilotCheckbox": ".edit-widget-pilot",
                "widgetNameInput": ".widget-name-input",
                "widgetIcon": ".widget-icon",
                "widgetDescription": ".widget-description",
                "widgetSizeDropdown": ".widget-size-dropdown",
                "widgetSkillMultiSelect": ".widget-skill-multiselect",
                "widgetURLLink": ".widget-URL-link",
                "widgetURL": ".widget-URL",
                "widgetURLPreview": ".widget-URL-preview",
                "widgetParamsCounter": ".widget-params-counter",
                "widgetURLPreviewContainer": ".widget-URL-preview-container",
                "addParamsButton": ".widget-params-button",
                "advancedSettings": ".advanced-settings-container",
                "advancedSettingsSection": ".advanced-settings-section-container",
                "widgetFallbackURL": ".widget-fallback-URL",
                "widgetFallbackURLTimeout": ".widget-fallback-URL-timeout-input"
            },
            uiComponents: {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK_NIGHT
                    },
                    events: {
                        "click": "_onCancelClick"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: "view._getSaveButtonState"
                    },
                    events: {
                        "click": "_onSaveClick"
                    }
                },
                pilotCheckBox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.pilotCheckbox",
                        permutation: Checkbox.PERMUTATION.NIGHT,
                        label: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.button.pilot"),
                        checked: "view.model.isPilotMode"
                    },
                    events: {
                        change: "_onPilotSelect"
                    }
                },
                nameInputField: {
                    type: InputField,
                    options: {
                        permutation: InputField.Permutation.P,
                        theme: InputField.THEME.NIGHT,
                        el: "view.ui.widgetNameInput",
                        maxLength: Config.iFrameWidget.widgetNameMaxLength,
                        value: "view.model.getName"
                    },
                    events: {
                        change: "_onWidgetNameChange"
                    }
                },
                widgetDescription: {
                    type: InlineTextarea,
                    options: {
                        permutation: InlineTextarea.PERMUTATION.C,
                        theme: InlineTextarea.THEME.NIGHT,
                        container: "view.ui.widgetDescription",
                        value: "view.model.getDescription"
                    },
                    events: {
                        change: "_onDescriptionChange"
                    }
                },
                sizeSelection: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.widgetSizeDropdown",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        selectedOption: "view.model.getSize",
                        testCollision: true,
                        items: "view._getWidgetSizesCollection"
                    },
                    events: {
                        "change": "_onSizeSelectionChange"
                    }
                },
                urlLinkButton: {
                    type: Button,
                    options: {
                        el: "view.ui.widgetURLLink",
                        permutation: Button.PERMUTATION.LIGHT_BLUELINK
                    },
                    events: {
                        "click": "_onURLLinkClick"
                    }
                },
                urlField: {
                    type: TextareaField,
                    options: {
                        permutation: TextareaField.PERMUTATION.G,
                        theme: TextareaField.THEME.NIGHT,
                        el: "view.ui.widgetURL",
                        value: "view.model.getURL",
                        maxChars: Config.iFrameWidget.widgetURLMaxLength
                    },
                    events: {
                        change: "_onURLChange"
                    }
                },
                addParamsButton: {
                    type: Button,
                    options: {
                        el: "view.ui.addParamsButton",
                        permutation: Button.PERMUTATION.BTN_NIGHT
                    },
                    events: {
                        "click": "_onAddParamsClick"
                    }
                },
                fallbackUrlField: {
                    type: TextareaField,
                    options: {
                        permutation: TextareaField.PERMUTATION.G,
                        theme: TextareaField.THEME.NIGHT,
                        el: "view.ui.widgetFallbackURL",
                        value: "view.model.getFallbackURL",
                        maxChars: Config.iFrameWidget.widgetFallbackURLMaxLength
                    },
                    events: {
                        change: "_onFallbackURLChange"
                    }
                },
                fallbackURLTimeout: {
                    type: InputField,
                    options: {
                        el: "view.ui.widgetFallbackURLTimeout",
                        permutation: InputField.Permutation.K,
                        theme: InputField.THEME.NIGHT,
                        value: "view.model.getFallbackURLTimeout",
                        maxLength: Config.iFrameWidget.widgetFallbackURLTimeout,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber
                    },
                    events: {
                        change: "_onFallbackURLTimeoutChange"
                    }
                }
            },
            events: {
                "click .edit-widget-close-btn": "_onCloseButtonClick",
                "click .advanced-settings-container.field-title-collapsible": "_onAdvancedSettingsClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing WidgetEditView", "WidgetEditView:initialize");
                this.vent = options.vent;
                this.paramsMap = options.paramsMap;
                this.paramsArrayTranslated = [];

                this.addCustomFields = options.addCustomFields;

                this._bindEvents();
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering WidgetEditView", "WidgetEditView:onRender");
                this._setWidgetIconLabel();
                if (this.model.getNumberOfParameters() !== 0) {
                    this._updateParametersURLPreview();
                }
                if (!_.isEmpty(this.model.get(WidgetModel.KEYS.FALLBACK_URL)) || !_.isEmpty(this.model.get(WidgetModel.KEYS.FALLBACK_URL_TIMEOUT))) {
                    this._onAdvancedSettingsClick();
                }

                if (this._isACUsers()) {
                    this._fetchSkills();
                }
            },

            customTemplateHelpers: function () {
                return {
                    isACUsers: this._isACUsers
                };
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetEditView", "WidgetEditView:onClose");
            },

            onInvalid: function (model, errors) {
                LEPersonalization.loader.closeLoader();

                if (_.has(errors, WidgetModel.KEYS.NAME)) {
                    this.uiComponents.nameInputField.setError(true, errors[WidgetModel.KEYS.NAME]);
                }
                if (_.has(errors, WidgetModel.KEYS.DESCRIPTION)) {
                    this.uiComponents.widgetDescription.setError(true, errors[WidgetModel.KEYS.DESCRIPTION]);
                }
                if (_.has(errors, WidgetModel.KEYS.URL)) {
                    this.uiComponents.urlField.setError(true, errors[WidgetModel.KEYS.URL]);
                }
                if (_.has(errors, WidgetModel.KEYS.FALLBACK_URL)) {
                    this.uiComponents.fallbackUrlField.setError(true, errors[WidgetModel.KEYS.FALLBACK_URL]);
                }
            },

            /************************** private functions *****************************************************/
            _bindEvents: function () {
                this.listenTo(this.model, "change:" + WidgetModel.KEYS.NAME, this._onWidgetModelNameChange);
                this.listenTo(this.model, "change:" + WidgetModel.KEYS.PARAMETERS, this._updateParametersURLPreview);
                this.listenTo(this.model, "change:" + WidgetModel.KEYS.URL, this._onWidgetModelURLChange);
            },

            _fetchSkills: function () {
                this.skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);

                this._showLoader();

                // in both cases we want to render the skill component. neither it will be rendered with updated data, nor without it
                this.skillsCollection.fetch({
                    success: _.bind(this._renderSkills, this),
                    error: _.bind(this._renderSkills, this)
                });
            },

            _renderSkills: function () {
                var skillsArray = this._parseSkills();

                this.uiComponents.host$.createAndRender("skillsMultiSelect", {
                    type: Multiselect,
                    options: {
                        container: "view.ui.widgetSkillMultiSelect",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        items: skillsArray,
                        list: {
                            theme: List.THEME.NIGHT,
                            maxShownItems: 6,
                            newItem: {
                                visible: false
                            }
                        },
                        tagsContainer: {
                            theme: TagsContainer.THEME.NIGHT,
                            placeholder: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.skill.placeholder"),
                            tagMaxWidth: "275px"
                        }
                    },
                    events: {
                        select: "_onSkillsChange",
                        unselect: "_onSkillsChange"
                    }
                });

                this._closeLoader();
            },


            _parseSkills: function () {
                var skillsArr = [];
                this.skillsCollection.each(function (skillModel) {
                    skillsArr.push({
                        id: skillModel.id,
                        value: skillModel.getName(),
                        selected: _.include(this.model.getSkills(), skillModel.id)
                    });
                }, this);
                return skillsArr;
            },

            _onWidgetModelURLChange: function () {
                this._toggleSaveButtonState();
                this._setURLPreview();
            },

            _updateParametersURLPreview: function () {
                this._translateParametersArray();
                this._setURLPreview();
                this._setParamsCounter();
                this.ui.widgetURLPreviewContainer.removeClass("hide");
            },

            _translateParametersArray: function () {
                var paramsArrayByPath = this.model.getParameters();
                this.paramsArrayTranslated = [];

                _.each(paramsArrayByPath, function (paramObj) {
                    var valueWithSpace = this.paramsMap[paramObj.value];
                    if (!valueWithSpace && this.addCustomFields) {
                        valueWithSpace = paramObj.value;
                    }
                    var valueWithUnderscore = valueWithSpace.replace(/\s+/g, "_").toLowerCase();

                    this.paramsArrayTranslated.push({name: paramObj.name, value: valueWithUnderscore});
                }, this);
            },

            _getSaveButtonState: function () {
                return this.model.isSaveAllowed() ? Button.STATES.ENABLED : Button.STATES.DISABLED;
            },

            _toggleSaveButtonState: function () {
                this.uiComponents.saveButton.setState(this._getSaveButtonState());
            },

            _setURLPreview: function () {
                var urlWithParams = lpUtils.getUrlWithParam(this.paramsArrayTranslated, this.model.getURL());
                this.ui.widgetURLPreview.text(urlWithParams);
            },

            _setParamsCounter: function () {
                var numberOfParams = this.model.getParameters().length;
                this.ui.widgetParamsCounter.text(numberOfParams + LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.parameters.counter.label"));
            },

            _onWidgetNameChange: function (componentId, eventName, value) {
                this.vent.trigger("widget-edit:change:name", {value: value});
            },

            _onWidgetModelNameChange: function () {
                this._toggleSaveButtonState();
                this._setWidgetIconLabel();
            },

            _setWidgetIconLabel: function () {
                this.ui.widgetIcon.text(this.model.getWidgetInitials());
            },

            _onDescriptionChange: function (componentId, eventName, value) {
                this.vent.trigger("widget-edit:change:description", {value: value});
            },

            _onSizeSelectionChange: function (componentId, eventName, value) {
                this.vent.trigger("widget-edit:change:size", {value: value.selectedKey});
            },

            _onSkillsChange: function (componentId, eventName, item) {
                var skills = this.uiComponents[componentId].getSelectedItems();
                this.vent.trigger("widget-edit:change:skills", {value: skills});
            },

            _onURLChange: function (componentId, eventName, value) {
                this.vent.trigger("widget-edit:change:URL", {value: value});
            },

            _onFallbackURLChange: function (componentId, eventName, value) {
                this.vent.trigger("widget-edit:change:FallbackURL", {value: value});
            },

            _onFallbackURLTimeoutChange: function (componentId, eventName, value) {
                this.vent.trigger("widget-edit:change:FallbackURLTimeoutChange", {value: value});
            },

            _onURLLinkClick: function () {
                this.vent.trigger("widget-edit:URL-link:click");
            },

            _onAddParamsClick: function () {
                this.vent.trigger("widget-edit:params-button:click");
            },

            _onPilotSelect: function (componentId, eventName, value) {
                this.vent.trigger("widget-edit:change:pilot", {value: value});
            },

            _onCancelClick: function () {
                this.vent.trigger("widget-edit:cancel");
            },

            _onSaveClick: function () {
                this.vent.trigger("widget-edit:save");
            },

            _onCloseButtonClick: function () {
                this.vent.trigger("widget-edit:cancel");
            },

            _onAdvancedSettingsClick: function () {
                this.ui.advancedSettings.toggleClass("opened");
                this.ui.advancedSettingsSection.toggleClass("hide");
            },

            /************************** Utility private functions that does not need "this" ********************/
            _getWidgetSizesCollection: function () {
                var sizesCollectionItems = new Dropdown.Collection();

                _.each(WidgetModel.SPANS, function (span) {
                    sizesCollectionItems.push({
                        key: span,
                        value: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.size." + span)
                    });
                });

                return sizesCollectionItems;
            },

            _isACUsers: function () {
                return CONST.SOURCE_ENUM.LEGACY !== LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.USERS_SOURCE);
            },

            _showLoader: function() {
                this.loader = new Loader({
                    permutation: Loader.PERMUTATION.M,
                    el: this.el,
                    zIndex: 1000
                });
                this.loader.render();
            },

            _closeLoader: function() {
                this.loader.close();
            }
        });
    });
    return WidgetEditView;
});

